function academicYearStartYear() {
  const now = new Date();
  const month = now.getMonth();
  const year = now.getFullYear();
  return month < 3 ? year - 1 : year;
}

export function buildAcademicYearOptions() {
  const start = academicYearStartYear();
  return [0, 1, 2].map((offset) => {
    const y = start + offset;
    const label = `${y}-${String(y + 1).slice(-2)}`;
    return { value: label, label };
  });
}

export const ACADEMIC_YEAR_OPTIONS = buildAcademicYearOptions();

export const SCHOOL_TYPE_OPTIONS = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'k12', label: 'K-12' },
  { value: 'higher_secondary', label: 'Higher Secondary' },
];
